var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1273_4769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint0_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint1_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint2_radial_1273_4769)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint3_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint4_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint5_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "url(#paint6_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 5,
    fill: "url(#paint7_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 13.5,
    r: 4.5,
    fill: "url(#paint8_radial_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16C12.9853 16 15 13.9853 15 11.5C15 9.01472 12.9853 7 10.5 7C8.01472 7 6 9.01472 6 11.5C6 13.9853 8.01472 16 10.5 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16C23.9853 16 26 13.9853 26 11.5C26 9.01472 23.9853 7 21.5 7C19.0147 7 17 9.01472 17 11.5C17 13.9853 19.0147 16 21.5 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "url(#paint9_linear_1273_4769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
    fill: "url(#paint10_linear_1273_4769)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 8,
    height: 10,
    rx: 4,
    fill: "url(#paint11_radial_1273_4769)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 9) rotate(131.878) scale(38.9487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 12.5) rotate(101.31) scale(17.8466 22.8581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 14) rotate(135) scale(41.0122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 17) rotate(77.692) scale(28.1469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 16.5) rotate(55.7131) scale(13.3135 9.65032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 18) rotate(9.86581) scale(11.6726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 15) rotate(43.9708) scale(59.0529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8889 9.11111) rotate(135) scale(9.74236 5.04232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23 10) rotate(135) scale(8.13173 4.59049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1273_4769",
    x1: 20.6154,
    y1: 10,
    x2: 19.9265,
    y2: 14.0302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1273_4769",
    x1: 20.6154,
    y1: 10,
    x2: 19.9265,
    y2: 14.0302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1273_4769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 30.2222) rotate(-90) scale(12.2222 9.77778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1273_4769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow);
export default __webpack_public_path__ + "static/media/wow.0ba48b8ab9d14544c7944caa289eea7c.svg";
export { ForwardRef as ReactComponent };